"use client";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { useTranslations } from "next-intl";

import { callConfig } from "@/config/communication.config";
import CallIcon from "@/icons/call.svg";
import { Button, ButtonProps } from "@/ui/Button";
import { cn } from "@/utils/cn";
import { fallBackHandler } from "@/utils/fallback-open-messenger"; // Assuming this is the correct import path for the fallback function

interface Props {
  buttonProps?: ButtonProps & { iconSize?: number };
  className?: string;
  id?: string;
}

export const CallButton = ({ buttonProps, className, id }: Props) => {
  const t = useTranslations();

  return (
    <div className={cn("w-full relative", className)}>
      <Dropdown
        placement="bottom"
        classNames={{
          base: "w-full",
          content: "min-w-0 w-full p-0 overflow-hidden rounded",
        }}
      >
        <DropdownTrigger>
          <Button
            disabled={!callConfig.length}
            className={cn("w-full", buttonProps?.className)}
            color={buttonProps?.color || "gray"}
            size={buttonProps?.size || "md"}
            radius={buttonProps?.radius || "sm"}
            variant={buttonProps?.variant || "bordered"}
          >
            <CallIcon
              width={buttonProps?.iconSize || 24}
              height={buttonProps?.iconSize || 24}
            />
            <span className="text-ellipsis overflow-hidden">
              {t("Call us")}
            </span>
          </Button>
        </DropdownTrigger>

        <DropdownMenu
          aria-label="Call options"
          className="w-full p-0"
          itemClasses={{
            base: "min-w-[20rem] outline-none cursor-pointer p-5 rounded-none transition-all duration-200 data-[hover=true]:text-white data-[hover=true]:bg-red data-[hover=true]:opacity-100",
          }}
        >
          {callConfig.map((item) => (
            <DropdownItem
              id={id ? item.id + "_" + id : item.id}
              key={item.value}
              startContent={
                <item.icon
                  width={35}
                  height={35}
                  className="mr-4 pointer-events-none"
                />
              }
              classNames={{
                title:
                  "text-ellipsis overflow-hidden text-md leading-tight font-medium pointer-events-none",
              }}
              onPress={() => fallBackHandler(item.link)}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
